import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import request from 'superagent';
import { flatten } from '../helpers';
import { TROLLEY_API_URL } from '../../config';
import { openModal, resetModal, updateModal, addTrolleyItem } from '.';
export var PREPARE_TROLLEY_REQUEST = 'PREPARE_TROLLEY_REQUEST';
export var PROCESS_TROLLEY_REQUEST = 'PROCESS_TROLLEY_REQUEST';
export var FAIL_TROLLEY_REQUEST = 'FAIL_TROLLEY_REQUEST';
export var COMPLETE_TROLLEY_REQUEST = 'COMPLETE_TROLLEY_REQUEST';
/**
 * Prepare trolley request for a product
 * @method prepareTrolleyRequest
 * @param  {String}  partNumber  The part number to use
 * @param  {Object}  setup       The initial setup for the request
 * @return {Action}              Action of PREPARE_TROLLEY_REQUEST type
 */

export var prepareTrolleyRequest = function prepareTrolleyRequest(partNumber) {
  return {
    type: PREPARE_TROLLEY_REQUEST,
    partNumber: partNumber
  };
};
/**
 * Process trolley request for a product
 * @method processingTrolleyRequest
 * @param  {String}  partNumber  The part number to use
 * @return {Action}              Action of PROCESS_TROLLEY_REQUEST type
 */

export var processTrolleyRequest = function processTrolleyRequest(partNumber) {
  return {
    type: PROCESS_TROLLEY_REQUEST,
    partNumber: partNumber
  };
};
/**
 * Mark trolley request as failed
 * @method failTrolleyRequest
 * @param  {String}  partNumber  The part number to use
 * @param  {String}  error  error message
 * @return {Action}              Action of FAIL_TROLLEY_REQUEST type
 */

export var failTrolleyRequest = function failTrolleyRequest(partNumber, error) {
  return {
    type: FAIL_TROLLEY_REQUEST,
    partNumber: partNumber,
    error: error
  };
};
/**
 * Mark trolley request as successfully completed
 * @method completeTrolleyRequest
 * @param  {String}    partNumber  The part number to use
 * @param  {Response}  payload     The response payload
 * @return {Action}                Action of COMPLETE_TROLLEY_REQUEST type
 */

export var completeTrolleyRequest = function completeTrolleyRequest(partNumber, payload) {
  return {
    type: COMPLETE_TROLLEY_REQUEST,
    partNumber: partNumber,
    payload: payload
  };
};
/**
 * Submit trolley request to the Trolley API
 * @method submitTrolleyRequest
 * @param  {String}       partNumber  The part number to use
 * @param  {String}       openView    Option to display the view
 * @return {ThunkAction}              Dispatcher of
 */

export var submitTrolleyRequest = function submitTrolleyRequest(partNumber) {
  var openView = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var onError = arguments.length > 2 ? arguments[2] : undefined;
  var onTrolleyRequestSuccess = arguments.length > 3 ? arguments[3] : undefined;
  return function (dispatch, getStore) {
    var _flatten = flatten(getStore()),
        trolley = _flatten.trolley;

    var payload = trolley[partNumber];
    var productMap = {};
    productMap.productId = Array.isArray(partNumber) ? partNumber[0] : partNumber;
    productMap.quantity = payload.quantity || 1;

    if (Array.isArray(partNumber)) {
      var bundleItems = _toConsumableArray(partNumber);

      bundleItems.shift();
      productMap.bundleItems = bundleItems;
    }

    var requestBody = productMap;

    if (openView) {
      dispatch(resetModal());
      dispatch(openModal());
    }

    dispatch(processTrolleyRequest(partNumber));
    request.post(TROLLEY_API_URL).send(requestBody).retry(3).end(function (error) {
      if (error) {
        var _error$response$body;

        dispatch(failTrolleyRequest(partNumber, (_error$response$body = error.response.body) === null || _error$response$body === void 0 ? void 0 : _error$response$body.error));
        onError(error.response.statusCode, error.response.statusText);
      } else {
        dispatch(addTrolleyItem(payload.partNumber));

        if (openView) {
          dispatch(updateModal(payload.partNumber, payload));
        }

        if (typeof onTrolleyRequestSuccess === 'function') {
          onTrolleyRequestSuccess();
        }
      }

      dispatch(completeTrolleyRequest(partNumber, productMap));
    });
  };
};
/**
 * Prepare trolley request for a given part number
 * @method prepareTrolleyRequestIfNeeded
 * @param  {String}       partNumber  The part number to use
 * @return {ThunkAction}              Dispatcher of PREPARE_TROLLEY_REQUEST
 */

export var prepareTrolleyRequestIfNeeded = function prepareTrolleyRequestIfNeeded(partNumber) {
  return function (dispatch, getStore) {
    var _flatten2 = flatten(getStore()),
        _flatten2$trolley = _flatten2.trolley,
        trolley = _flatten2$trolley === void 0 ? {} : _flatten2$trolley;

    if (!trolley[partNumber]) {
      dispatch(prepareTrolleyRequest(partNumber));
    }
  };
};